import { z } from 'zod';

import { defineService } from '@@api/lib/defineService';
import {
    ProposeToDictionaryRequestBody,
    SpellCheckRequestBody,
    SpellCheckResponseBody,
} from '@@api/services/spellChecker/schemas';
import { SearchParams } from '@@api/utils/schemas/queryParams';
import { Ids } from '@@api/utils/schemas/schemas';
import config from '@@config';

export const spellcheckerService = defineService(
    (defineEndpoint) => ({
        spellCheck: {
            post: defineEndpoint({
                method: 'POST',
                path: '/spell-check',
                query: z.object({
                    ...SearchParams.pick({ tenantIds: true }).shape,
                }),
                body: SpellCheckRequestBody,
                responses: {
                    200: SpellCheckResponseBody,
                },
            }),
        },
        proposal: {
            post: defineEndpoint({
                method: 'POST',
                path: '/dictionary-proposals',
                query: z.object({
                    tenantIds: Ids,
                }),
                body: ProposeToDictionaryRequestBody,
                responses: {
                    201: z.never(),
                },
            }),
        },
    }),
    {
        baseUrl: config.apiEnvVars.spellCheckerUrl,
    },
);
